import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperRounds: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    flagIcon: {
        width: 18,
        height: 18,
        objectFit: "contain",
        marginRight: 8,
    },
    chipIcon: {
        width: 28,
        height: 28,
        objectFit: "contain",
        [theme.breakpoints.down("lg")]: {
            height: "100%",
            aspectRatio: "1 / 1",
        },
        [theme.breakpoints.down("sm")]: {
            height: "75%",
        },
    },
    roundsLabel: {
        fontSize: 20,
        lineHeight: "24px",
        fontWeight: 400,
        color: "#F5F5F5CC",
        [theme.breakpoints.down("lg")]: {
            fontSize: 18,
            lineHeight: "20px",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: 16,
            lineHeight: "18px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
            lineHeight: "14px",
        },
    },
});
